const Step = () =>
  import(
    /* webpackChunkName: "Step" */ "@/components/AccountPage/Security/SecurityTwoFactorAuth/Stepper/Step/index"
  );

const Spacer = () =>
  import(
    /* webpackChunkName: "Spacer" */ "@/components/AccountPage/Security/SecurityTwoFactorAuth/Stepper/Spacer/index"
  );

export default {
  name: "stepper",
  components: { Step, Spacer },
  props: ["currentStep"],
  data() {
    return {};
  }
};
